// @flow

import type { VbmrState } from './types';

export type GlobalState = {
  vbmr: VbmrState,
};

export const getReducer = (state: GlobalState): VbmrState => state.vbmr;

export const getVbmrAvailability = (state: GlobalState): boolean => getReducer(state).isAvailable;

export const getLabel = (state: GlobalState): string => getReducer(state).label || 'VBMR';

export default null;
